import type { StatusTone } from '~/components/ui';

export type AiStatus = 'draft' | 'published' | 'active' | 'inactive' | 'completed' | 'failed';

export const AI_STATUS_LABELS: Record<AiStatus, string> = {
  draft: 'Draft',
  published: 'Active',
  active: 'Active',
  inactive: 'Inactive',
  completed: 'Completed',
  failed: 'Failed',
};

export const AI_STATUS_TONES: Record<AiStatus, StatusTone> = {
  draft: 'draft',
  published: 'success',
  active: 'success',
  inactive: 'neutral',
  completed: 'success',
  failed: 'error',
};

/** Label and tone for a status (already lowercase, `modules/query/ai` normalizes it, D-24); an unknown one reads "Unknown", never raw enum text. */
export const aiStatus = (status: string): { label: string; tone: StatusTone } => {
  const key = status as AiStatus;
  return key in AI_STATUS_LABELS
    ? { label: AI_STATUS_LABELS[key], tone: AI_STATUS_TONES[key] }
    : { label: 'Unknown', tone: 'neutral' };
};
